// extracted by mini-css-extract-plugin
export var label = "_dc-1";
export var reminder = "_dc-0";